export function initializeScrollSpy(root) {
	const scrollspy = root.querySelector('[data-init="scrollspy"]');
	const scrollspyLinks = scrollspy ? [...scrollspy.querySelectorAll('a[data-toggle="scroll-to"]')] : [];
	const scrollspyItems = scrollspyLinks
		.map((link) => ({ link, section: root.querySelector(link.getAttribute('href')) }))
		.filter(({ section }) => section);
	let scrollContainer = window;
	let scrollParent = root.parentElement;
	let scrollspyFrame = null;

	while (scrollParent && scrollParent !== document.body) {
		const overflowY = getComputedStyle(scrollParent).overflowY;
		if (overflowY === 'auto' || overflowY === 'scroll') {
			scrollContainer = scrollParent;
			break;
		}
		scrollParent = scrollParent.parentElement;
	}

	const updateScrollspy = () => {
		const containerTop = scrollContainer === window ? 0 : scrollContainer.getBoundingClientRect().top;
		const activeItem = scrollspyItems.reduce((active, item) => {
			return item.section.getBoundingClientRect().top <= containerTop + 120 ? item : active;
		}, scrollspyItems[0]);

		if (activeItem) {
			scrollspyLinks.forEach((link) => link.classList.toggle('active', link === activeItem.link));
		}
	};
	const handleScroll = () => {
		if (scrollspyFrame === null) {
			scrollspyFrame = window.requestAnimationFrame(() => {
				scrollspyFrame = null;
				updateScrollspy();
			});
		}
	};

	if (scrollspyItems.length) {
		scrollContainer.addEventListener('scroll', handleScroll, { passive: true });
		updateScrollspy();
	}

	return () => {
		if (scrollspyItems.length) scrollContainer.removeEventListener('scroll', handleScroll);
		if (scrollspyFrame !== null) window.cancelAnimationFrame(scrollspyFrame);
	};
}
